var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"charts",style:({ height: '100%', width: '100%' })})
}
var staticRenderFns = []

export { render, staticRenderFns }